import { Link } from "react-router-dom";
import { LogoMarkV2 } from "@/components/v2/LogoV2";
import { cn } from "@/lib/utils";

export const LogoMark = LogoMarkV2;

export const Logo = ({ light = false, tagline = true, className }) => (
  <Link to="/" data-testid="logo-home-link" aria-label="PRICEHUB home" className={cn("group flex items-center gap-3", className)}>
    <span className="transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-105"><LogoMarkV2 /></span>
    <span className="flex flex-col leading-none">
      <span className={cn("font-display text-[1.4rem] font-extrabold tracking-[-0.03em]", light ? "text-[#F6F8FC]" : "text-ph-ink")}>
        PRICE<span className={light ? "text-[#B6FF5C]" : "text-ph-accent"}>HUB</span>
      </span>
      {tagline && (
        <span className={cn("mt-1 font-mono-ph text-[10px] uppercase tracking-[0.2em]", light ? "text-[#A8B3C9]" : "text-ph-muted")}>
          Every Brand. Every Price List.
        </span>
      )}
    </span>
  </Link>
);
